exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul.dash[data-v-388e2e56] {\n  list-style: none;\n  margin-left: 0;\n  padding-left: 1em;\n}\nul.dash > li[data-v-388e2e56]:before {\n  display: inline-block;\n  content: \"-\";\n  width: 1em;\n  margin-left: -1em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-388e2e56","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/information/ServiceProviderPrivacy.vue
// module id = 1471
// module chunks = 0